module.exports = __webpack_public_path__ + "media/tada.33b92fe0.mp3";